import React, { useState, useEffect } from "react";
import { useContext } from "react";
import ReactPaginate from "react-paginate";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../App";
import Nodata from "../../../assets/Icon/Nodata.png";
const PromoNavigation = (props) => {
  console.log("promo", props);

  const { videoCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 8;
  const { data, fileLink } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      {currentItems.length !== 0 ? (
        <>
          <div className="py-3">
            <div className="row ">
              {currentItems.map((event) => {
                return (
                  <>
                    <div className="col-md-3 p-3">
                      <div className="card bg-dark">
                        <center>
                          <ReactPlayer
                            url={
                              videoCdnUrl + event.video_url
                                ?videoCdnUrl + event.video_url
                                : null
                            }
                            autoplay
                            controls="true"
                            width={200}
                          />
                        </center>

                        {props.urlLink ? (
                          <Link
                            to={`${props.urlLink}/${event.id}`}
                            className="Link"
                          >
                            <p className="text-secondary head-line p-2 text-warning mt-2">
                              {event.title}
                            </p>
                          </Link>
                        ) : (
                          <p className="text-secondary head-line p-2 text-warning mt-2">
                            {event.title}
                          </p>
                        )}
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <div id="react-paginate">
            <ReactPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              breakLinkClassName={"page-link"}
              containerClassName={"pagination"}
              pageLinkClassName={"page-link"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </>
      ) : (
        <>
          <div className="row justify-content-center align-items-center">
            <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
              <img src={Nodata} alt="" className=" Nodata" />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PromoNavigation;
